{
  "about.blocks": "Jerata servili",
  "about.contact": "Kontaktajo:",
  "about.default_locale": "Predeterminita",
  "about.disclaimer": "Mastodon esas libera, publikfonta e komercmarko di Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Expliko nedisponebla",
  "about.domain_blocks.preamble": "Mastodon generale permisas on vidar kontenajo e interagar kun uzanti de irga altra servilo en fediverso. Existas eceptioni quo facesis che ca partikulara servilo.",
  "about.domain_blocks.silenced.explanation": "On generale ne vidar profili e enhavajo de ca servilo, se on ne intence serchar o voleskar per sequar.",
  "about.domain_blocks.silenced.title": "Limitizita",
  "about.domain_blocks.suspended.explanation": "Nula informi de ca servili procedagesos o retenesos o interchanjesos, do irga interago o komuniko kun uzanti de ca servili esas neposibla.",
  "about.domain_blocks.suspended.title": "Restriktita",
  "about.language_label": "Linguo",
  "about.not_available": "Ca informo ne igesis che ca servilo.",
  "about.powered_by": "Necentraligita sociala ret quo povigesas da {mastodon}",
  "about.rules": "Servilreguli",
  "account.account_note_header": "Personala noto",
  "account.activity": "Ago",
  "account.add_note": "Adjuntez personala noto",
  "account.add_or_remove_from_list": "Adjuntar o forigar de listi",
  "account.badges.admin": "Administranto",
  "account.badges.blocked": "Blokusita",
  "account.badges.bot": "Boto",
  "account.badges.domain_blocked": "Blokusita domeno",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silencigata",
  "account.badges.muted_until": "Silencigita til {until}",
  "account.block": "Blokusar @{name}",
  "account.block_domain": "Blokusar {domain}",
  "account.block_short": "Blokusar",
  "account.blocked": "Blokusita",
  "account.cancel_follow_request": "Desendez sequodemando",
  "account.copy": "Kopiez ligilo al profilo",
  "account.direct": "Private mencionez @{name}",
  "account.disable_notifications": "Cesez avizar me kande @{name} postas",
  "account.edit_note": "Redaktez personala noto",
  "account.edit_profile": "Redaktar profilo",
  "account.edit_profile_short": "Redaktez",
  "account.enable_notifications": "Avizez me kande @{name} postas",
  "account.endorse": "Traito di profilo",
  "account.featured": "Estalita",
  "account.featured.accounts": "Profili",
  "account.featured.collections": "Kolektaji",
  "account.filters.all": "Omna ago",
  "account.filters.boosts_toggle": "Montrez diskonoci",
  "account.filters.posts_boosts": "Afishi e diskonoci",
  "account.filters.posts_only": "Afishi",
  "account.filters.posts_replies": "Afishi e respondi",
  "account.filters.replies_toggle": "Montrez respondi",
  "account.follow": "Sequar",
  "account.follow_back": "Anke sequez",
  "account.follow_request_cancel": "Anulez demando",
  "account.follow_request_cancel_short": "Anulez",
  "account.follow_request_short": "Demandez",
  "account.followers": "Sequanti",
  "account.followers.empty": "Nulu sequas ca uzanto til nun.",
  "account.followers_counter": "{count, plural,one {{counter} sequanto} other {{counter} sequanti}}",
  "account.following": "Sequata",
  "account.following_counter": "{count, plural,one {{counter} sequato} other {{counter} sequati}}",
  "account.follows.empty": "Ca uzanto ne sequa irgu til nun.",
  "account.follows_you": "Sequas vu",
  "account.go_to_profile": "Irez al profilo",
  "account.hide_reblogs": "Celez repeti de @{name}",
  "account.in_memoriam": "Memorige.",
  "account.joined_short": "Juntita",
  "account.languages": "Chanjez abonita lingui",
  "account.link_verified_on": "Proprieteso di ca ligilo kontrolesis ye {date}",
  "account.locked_info": "La privatesostaco di ca konto fixesas quale lokata. Proprietato manue kontrolas personi qui povas sequar.",
  "account.media": "Audvidaji",
  "account.mention": "Mencionar @{name}",
  "account.menu.add_to_list": "Adjuntez ad listo…",
  "account.menu.block": "Blokusez konto",
  "account.menu.block_domain": "Blokuez {domain}",
  "account.menu.direct": "Private mencionez",
  "account.menu.hide_reblogs": "Celez diskonoci en tempolineo",
  "account.menu.mention": "Mencionez",
  "account.menu.mute": "Silencigez konto",
  "account.menu.open_original_page": "Videz che {domain}",
  "account.menu.remove_follower": "Efacez sequanto",
  "account.menu.report": "Efacez konto",
  "account.menu.share": "Kunhavigez…",
  "account.menu.show_reblogs": "Montrez diskonoci en tempolineo",
  "account.menu.unblock": "Retroblokusez konto",
  "account.menu.unblock_domain": "Retroblokusez {domain}",
  "account.menu.unmute": "Retrosilencigez konto",
  "account.moved_to": "{name} indikis ke lua nova konto es nune:",
  "account.mute": "Celar @{name}",
  "account.mute_notifications_short": "Silencigez avizi",
  "account.mute_short": "Silencigez",
  "account.muted": "Silencigata",
  "account.name.help.header": "Nometo esas kam retpostadreso",
  "account.no_bio": "Deskriptajo ne provizesis.",
  "account.open_original_page": "Apertez originala pagino",
  "account.posts": "Mesaji",
  "account.report": "Denuncar @{name}",
  "account.requested_follow": "{name} demandis sequar tu",
  "account.share": "Partigez profilo di @{name}",
  "account.show_reblogs": "Montrez repeti de @{name}",
  "account.statuses_counter": "{count, plural,one {{counter} mesajo} other {{counter} mesaji}}",
  "account.unblock": "Desblokusar @{name}",
  "account.unblock_domain": "Desblokusar {domain}",
  "account.unblock_short": "Desblokusar",
  "account.unendorse": "Ne estalez che profilo",
  "account.unfollow": "Ne plus sequar",
  "account.unmute": "Ne plus celar @{name}",
  "account.unmute_notifications_short": "Dessilencigez avizi",
  "account.unmute_short": "Desilencigez",
  "account_edit.custom_fields.placeholder": "Adjuntez vua pronomi, externa ligili o altra irgo quan vu volas kunhavigar.",
  "account_edit.display_name.add_label": "Adjuntez nometo",
  "account_edit.display_name.edit_label": "Redaktez nometo",
  "account_edit.display_name.placeholder": "Vua nometo esas quale vua nomo aparas che vua profilo e en tempolinei.",
  "account_edit.display_name.title": "Nometo",
  "account_edit.featured_hashtags.edit_label": "Adjuntez gretvorti",
  "account_edit.featured_hashtags.placeholder": "Helpez altru identifikar e havez rapida aceso por vua prizita topiki.",
  "account_edit.featured_hashtags.title": "Estalita gretvorti",
  "account_edit.field_edit_modal.length_warning": "Rekomendita literlimito esis ecesita.",
  "account_edit.field_edit_modal.link_emoji_warning": "Ni desrekomendas uzar kustuma emoji kun url.",
  "account_edit.field_edit_modal.url_warning": "Por adjuntar ligilo, inkluzez {protocol} che la komenco.",
  "account_edit.name_modal.add_title": "Adjuntez nometo",
  "account_edit.name_modal.edit_title": "Redaktez nometo",
  "account_edit.profile_tab.button_label": "Kustumizez",
  "account_edit.profile_tab.hint.description": "Ca preferaji kustumizas quon uzanti vidas che {server} per oficala softwari, me li forsan ne esas sama ad uzanti che altra servili e desoficala softwari.",
  "account_edit.profile_tab.hint.title": "Vidi ankore esas chanjita",
  "account_edit.profile_tab.show_featured.description": "'Estalita' esas nemusta langeto ube vu povas dismontrar altra konti.",
  "account_edit.profile_tab.show_featured.title": "Montrez 'Estalita'-langeto",
  "account_edit.profile_tab.show_media.description": "'Audvidajo' esas desmusta langeto qua montras vua posti qui kontenas imaji o videii.",
  "account_edit.profile_tab.show_media.title": "Montrez 'Audvidajo'-langeto",
  "account_edit.profile_tab.show_media_replies.description": "Kande aktivigita, audvidajlangeto montras ambe vua afishi e respondi ad afishi di altra personi.",
  "account_edit.profile_tab.show_media_replies.title": "Inkluzas respondi che 'Audvidajo'-langeto",
  "account_edit.verified_modal.invisible_link.details": "Adjuntez la ligilo ad vua kapimajo. Vu anke povas uzar ligiletiketo en la kapimajo di la pagino vice {tag}, ma la HTML mustas esar acesebla sen exekutar JavaScript.",
  "account_edit_tags.help_text": "Estalita gretvorti helpas uzanti deskovrar e interagar kun vua profilo.",
  "account_edit_tags.max_tags_reached": "Vu atingas la maxim quanto di estalita gretvorti.",
  "account_note.placeholder": "Klikez por adjuntar noto",
  "admin.dashboard.daily_retention": "Dia uzantoretenseso pos registro",
  "admin.dashboard.monthly_retention": "Monata uzantoreteneso pos registro",
  "admin.dashboard.retention.average": "Averajo",
  "admin.dashboard.retention.cohort": "Registromonato",
  "admin.dashboard.retention.cohort_size": "Nova uzanti",
  "admin.impact_report.instance_accounts": "Kontala profili quin co efacus",
  "admin.impact_report.instance_followers": "Sequanti quin nia uzanti perdus",
  "admin.impact_report.instance_follows": "Sequanti quin lia uzanti perdus",
  "admin.impact_report.title": "Rezumo dil efekto",
  "alert.rate_limited.message": "Riprobez pos {retry_time, time, medium}.",
  "alert.rate_limited.title": "Demandi limitizita",
  "alert.unexpected.message": "Neexpektita eroro eventis.",
  "alert.unexpected.title": "Problemo!",
  "alt_text_badge.title": "Alternativa texto",
  "alt_text_modal.add_alt_text": "Adjuntar alternativa texto",
  "alt_text_modal.add_text_from_image": "Adjuntar texto de imajo",
  "alt_text_modal.cancel": "Nuligar",
  "alt_text_modal.change_thumbnail": "Chanjar imajeto",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Priskribar co por personi kun auddeskapableso…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Priskribar co por personi kun viddeskapableso…",
  "alt_text_modal.done": "Finis",
  "announcement.announcement": "Anunco",
  "annual_report.shared_page.donate": "Donacez",
  "annual_report.shared_page.footer": "Igita kun {heart} da la grupo di Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} uzas {domain}, un de multa komunitati quin povizita da Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} dauras serchar afishi por diskonoci e pluigas altra kreanti.",
  "annual_report.summary.archetype.booster.desc_self": "Vu dauras serchar afishi por diskonoci e pluigas altra kreanti.",
  "annual_report.summary.archetype.booster.name": "La arkisto",
  "annual_report.summary.archetype.lurker.desc_public": "Ni povas ke {name} esas ulaloke e juas Mastodon.",
  "annual_report.summary.archetype.lurker.desc_self": "Ni savas ke vu esas ulaloke e juas Mastodon.",
  "annual_report.summary.highlighted_post.boost_count": "Ca afisho esis diskonocita {count, plural,one {unfoye} other {# foye}}.",
  "annual_report.summary.most_used_app.most_used_app": "maxim uzita aplikajo",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "maxim uzita gretvorto",
  "annual_report.summary.new_posts.new_posts": "nova afishi",
  "annual_report.summary.percentile.text": "<topLabel>To pozas vu sur la supro </topLabel><percentage></percentage><bottomLabel>di uzanti di {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ni ne dicas ad Bernio.",
  "annual_report.summary.share_elsewhere": "Havigez ad altra loki",
  "annual_report.summary.share_message": "Me ganas la persontipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Kunhavigez che Mastodon",
  "attachments_list.unprocessed": "(neprocedita)",
  "audio.hide": "Celez audio",
  "block_modal.remote_users_caveat": "Ni questionos {domain} di la servilo por respektar vua decido. Publika posti forsan ankore estas videbla a neenirinta uzanti.",
  "block_modal.show_less": "Montrar mine",
  "block_modal.show_more": "Montrar plu",
  "block_modal.they_will_know": "Oli povas vidar ke oli esas blokusita.",
  "block_modal.title": "Blokusar uzanto?",
  "boost_modal.combo": "Vu povas pulsar {combo} por omisar co venontafoye",
  "boost_modal.reblog": "Ka repetar posto?",
  "boost_modal.undo_reblog": "Ka desrepetar posto?",
  "bundle_column_error.copy_stacktrace": "Kopierorraporto",
  "bundle_column_error.error.body": "La demandita pagino ne povas strukturigesar. Forsan ol esas eroro en kodexo hike o vidilkoncilieblesproblemo.",
  "bundle_column_error.error.title": "Ach!",
  "bundle_column_error.network.body": "Havas eroro kande probar montrar ca pagino. Forsan ol esas tempala problemo kun vua retkonekteso o ca servilo.",
  "bundle_column_error.network.title": "Reteroro",
  "bundle_column_error.retry": "Probez itere",
  "bundle_column_error.return": "Irez a hemo",
  "bundle_column_error.routing.body": "Demandita pagino ne povas trovesar. Ka vu certe ke URL en situobuxo esar korekta?",
  "bundle_column_error.routing.title": "Eroro di 404",
  "bundle_modal_error.close": "Klozez",
  "bundle_modal_error.message": "Ulo nefuncionas dum chargar ca skreno.",
  "bundle_modal_error.retry": "Probez itere",
  "closed_registrations.other_server_instructions": "Nam Mastodon es descentraligita, on povas krear konto che altra servilo e senegarde interagar kun ca servilo.",
  "closed_registrations_modal.description": "Nune on ne povas krear konto che {domain}, ma voluntez savar ke on ne bezonas konto specifike che {domain} por uzar Mastodon.",
  "closed_registrations_modal.find_another_server": "Trovar altra servilo",
  "closed_registrations_modal.preamble": "Mastodon es descentraligita, do on povas krear konto che irga servilo e sequar e interagar kun irgu che ca servilo. On mem povas operacar servilo ipse!",
  "closed_registrations_modal.title": "Krear konto che Mastodon",
  "collection.share_modal.share_via_post": "Afishigez che Mastodon",
  "collection.share_modal.share_via_system": "Kunhavigez ad…",
  "collection.share_modal.title": "Kunhavigez kolektajo",
  "collection.share_modal.title_new": "Kunhavigez vua nova kolektajo!",
  "collection.share_template_other": "Videz ca splendida kolektajo: {link}",
  "collection.share_template_own": "Videz mia nova kolektajo: {link}",
  "collections.content_warning": "Kontenajaverto",
  "collections.create.accounts_title": "Quan vu estalos en ca kolektajo?",
  "collections.detail.share": "Kunhavigez ca kolektajo",
  "collections.mark_as_sensitive_hint": "Celas deskripto di la kolektajo e konti dop kontenajaverto.",
  "column.about": "Pri co",
  "column.blocks": "Blokusita uzeri",
  "column.bookmarks": "Lektosigni",
  "column.community": "Lokala tempolineo",
  "column.create_list": "Krear listo",
  "column.direct": "Privata mencioni",
  "column.directory": "Videz profili",
  "column.domain_blocks": "Blokusita domeni",
  "column.edit_list": "Redaktar listo",
  "column.favourites": "Favoriziti",
  "column.firehose": "Nuna flui",
  "column.follow_requests": "Demandi di sequado",
  "column.home": "Hemo",
  "column.list_members": "Administrar listomembri",
  "column.lists": "Listi",
  "column.mutes": "Celita uzeri",
  "column.notifications": "Savigi",
  "column.pins": "Adpinglita afishi",
  "column.public": "Federata tempolineo",
  "column_back_button.label": "Retro",
  "column_header.hide_settings": "Celez ajusti",
  "column_header.moveLeft_settings": "Movez kolumno a la sinistro",
  "column_header.moveRight_settings": "Movez kolumno a la dextro",
  "column_header.pin": "Pinglagez",
  "column_header.show_settings": "Montrez ajusti",
  "column_header.unpin": "Depinglagez",
  "column_search.cancel": "Nuligar",
  "community.column_settings.local_only": "Lokala nur",
  "community.column_settings.media_only": "Nur audvidaji",
  "community.column_settings.remote_only": "Fora nur",
  "compose.language.change": "Chanjez linguo",
  "compose.language.search": "Trovez linguo...",
  "compose.published.body": "Posto publikigita.",
  "compose.published.open": "Apertez",
  "compose.saved.body": "Posto konservita.",
  "compose_form.direct_message_warning_learn_more": "Lernez plu",
  "compose_form.encryption_warning": "Posti en Mastodon ne intersequante chifrigesas. Ne partigez irga privata informo che Mastodon.",
  "compose_form.hashtag_warning": "Ca afisho ne listigesos kun irga gretvorto pro ke ol ne es publika.",
  "compose_form.lock_disclaimer": "Vua konto ne esas {locked}. Irgu povas sequar vu por vidar vua sequanto-nura posti.",
  "compose_form.lock_disclaimer.lock": "klefagesas",
  "compose_form.placeholder": "Quon vu pensas?",
  "compose_form.poll.duration": "Votinquestoduro",
  "compose_form.poll.multiple": "Multopla selekteso",
  "compose_form.poll.option_placeholder": "Selektato {number}",
  "compose_form.poll.single": "Unopla selektato",
  "compose_form.poll.switch_to_multiple": "Chanjar votinquesto por permisar multopla selektati",
  "compose_form.poll.switch_to_single": "Chanjez votinquesto por permisar unopla selektato",
  "compose_form.poll.type": "Stilo",
  "compose_form.publish": "Posto",
  "compose_form.reply": "Respondez",
  "compose_form.save_changes": "Aktualigez",
  "compose_form.spoiler.marked": "Text is hidden behind warning",
  "compose_form.spoiler.unmarked": "Text is not hidden",
  "compose_form.spoiler_placeholder": "Kontenajaverto (selektebla)",
  "confirmation_modal.cancel": "Anulez",
  "confirmations.block.confirm": "Restriktez",
  "confirmations.delete.confirm": "Efacez",
  "confirmations.delete.message": "Are you sure you want to delete this status?",
  "confirmations.delete.title": "Ka efacar posto?",
  "confirmations.delete_list.confirm": "Efacez",
  "confirmations.delete_list.message": "Ka vu certe volas netempale efacar ca listo?",
  "confirmations.delete_list.title": "Ka efacar listo?",
  "confirmations.discard_edit_media.confirm": "Forigar",
  "confirmations.discard_edit_media.message": "Vu havas nekonservita chanji di audvidajpriskribo o prevido, ka forigas ili irgakaze?",
  "confirmations.follow_to_list.confirm": "Sequar e adjuntar ad listo",
  "confirmations.follow_to_list.message": "Vu bezonas sequar {name} por adjuntar lu ad listo.",
  "confirmations.follow_to_list.title": "Ka sequar uzanto?",
  "confirmations.logout.confirm": "Ekirez",
  "confirmations.logout.message": "Ka tu certe volas ekirar?",
  "confirmations.logout.title": "Ka ekirar?",
  "confirmations.missing_alt_text.confirm": "Adjuntar alternativa texto",
  "confirmations.missing_alt_text.message": "Vua afisho enhavas audvidaji sen alternativa texto.",
  "confirmations.missing_alt_text.secondary": "Mesajar irgamaniere",
  "confirmations.missing_alt_text.title": "Ka adjuntar alternativa texto?",
  "confirmations.mute.confirm": "Silencigez",
  "confirmations.private_quote_notify.cancel": "Retro ad redakto",
  "confirmations.private_quote_notify.confirm": "Publikigez afisho",
  "confirmations.private_quote_notify.do_not_show_again": "Ne montrez ca mesajo ankorfoye ad me",
  "confirmations.private_quote_notify.message": "La persono quan vua citas e altra mencioni esar savigos e povos vidar vua afisho, mem se li ne sequas vua.",
  "confirmations.private_quote_notify.title": "Ka kunhavigez kun sequanti e mencionita uzanti?",
  "confirmations.quiet_post_quote_info.dismiss": "Ne memorigez me ankorfoye",
  "confirmations.quiet_post_quote_info.got_it": "Komprenas",
  "confirmations.quiet_post_quote_info.message": "Kande citar deslauta publika afisho, vua afisho esar celitos de tendenca tempolinei.",
  "confirmations.quiet_post_quote_info.title": "Citas deslauta publika afishi",
  "confirmations.redraft.confirm": "Efacez e riskisez",
  "confirmations.redraft.message": "Ka vu certe volas efacar ca posto e riskisigar ol? Favoriziti e repeti esos perdita, e respondi al posto originala esos orfanigita.",
  "confirmations.redraft.title": "Ka efacar & riskisar posto?",
  "confirmations.revoke_quote.confirm": "Efacez afisho",
  "confirmations.revoke_quote.message": "Ca ago ne povas esar retroagar.",
  "confirmations.revoke_quote.title": "Ka efacez afisho?",
  "confirmations.unfollow.confirm": "Desequez",
  "content_warning.hide": "Celez posto",
  "content_warning.show": "Montrez nur",
  "content_warning.show_more": "Montrar plu",
  "conversation.delete": "Efacez konverso",
  "conversation.mark_as_read": "Markizez quale lektita",
  "conversation.open": "Videz konverso",
  "conversation.with": "Kun {names}",
  "copy_icon_button.copied": "Kopiita",
  "copypaste.copied": "Kopiesis",
  "copypaste.copy_to_clipboard": "Kopiez",
  "directory.federated": "De savita fediverso",
  "directory.local": "De {domain} nur",
  "directory.new_arrivals": "Nova venanti",
  "directory.recently_active": "Recenta aktivo",
  "disabled_account_banner.account_settings": "Kontala opcioni",
  "disabled_account_banner.text": "Vua konto {disabledAccount} es nune desaktivigita.",
  "dismissable_banner.community_timeline": "Co esas maxim recenta publika posti de personi quo havas konto quo hostigesas da {domain}.",
  "dismissable_banner.dismiss": "Ignorez",
  "dismissable_banner.public_timeline": "Co es la maxim lastatempa publika afishi di personi sur la fediverso qua personi di {domain} sequas.",
  "domain_block_modal.block": "Blokusez servilo",
  "domain_block_modal.block_account_instead": "Blokusez @{name} vice",
  "domain_block_modal.they_can_interact_with_old_posts": "Personi de ca servilo povas interagar kun vua desnova posti.",
  "domain_block_modal.they_cant_follow": "Nulu de ca servilo povas sequar vu.",
  "domain_block_modal.they_wont_know": "Lu ne savos ke lu blokusesis.",
  "domain_block_modal.title": "Ka blokusar domeno?",
  "domain_block_modal.you_will_lose_num_followers": "Vu desganos {followersCount, plural, one {{followersCountDisplay} sequanto} other {{followersCountDisplay} sequanti}} e {followingCount, plural, one {{followingCountDisplay} persono quan vu sequas} other {{followingCountDisplay} personi quan vu sequas}}.",
  "domain_block_modal.you_will_lose_relationships": "Vu desganos omna sequanti e sequati de ca servilo.",
  "domain_block_modal.you_wont_see_posts": "Vu ne vidos postoi o savigi de uzanti en ca servilo.",
  "domain_pill.activitypub_lets_connect": "Ol povigas vu kuneskas e interagar kun personi ne nur sur Mastodon, o anke kun dessama socia softwari.",
  "domain_pill.activitypub_like_language": "ActivityPub esas kam linguo quan Mastodon parolas kun altra socia reti.",
  "domain_pill.server": "Servilo",
  "domain_pill.their_handle": "Lua nomo:",
  "domain_pill.their_server": "Lua komputala hemo, e havas omna lua posti.",
  "domain_pill.their_username": "Lua unika identesilo sur lua servilo. Posible trovar uzanti kun sama uzantonomo sur dessama servili.",
  "domain_pill.username": "Uzantonomo",
  "domain_pill.whats_in_a_handle": "Quo esas nomo?",
  "domain_pill.who_they_are": "Pro ke nomo esas deskripto di ulu, vu povas interagar kun personi tra socia interreto kun <button>ActivityPub-povizo</button>.",
  "domain_pill.who_you_are": "Pro ke vua nomo esas deskripto pri vu e vua situo, personi povas interagar kun vu tra socia interreto kun <button>ActivityPub-povizo</button>.",
  "domain_pill.your_handle": "Vua nomo:",
  "domain_pill.your_server": "Vua komputerala hemo qua havas omna vua posti. On povas transferar a altra servili ulatempe e anke adportar vua sequanti.",
  "domain_pill.your_username": "Vua unika identesilo sur lua servilo. Posible trovar uzanti kun sama uzantonomo sur dessama servili.",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "Co esas quon ol semblos tale:",
  "emoji_button.activity": "Ago",
  "emoji_button.clear": "Efacez",
  "emoji_button.custom": "Kustumizato",
  "emoji_button.flags": "Flagi",
  "emoji_button.food": "Manjajo & Drinkajo",
  "emoji_button.label": "Enpozar emocimajo",
  "emoji_button.nature": "Naturo",
  "emoji_button.not_found": "Nula tala parigata emojii",
  "emoji_button.objects": "Kozi",
  "emoji_button.people": "Personi",
  "emoji_button.recent": "Ofta uzato",
  "emoji_button.search": "Trovez...",
  "emoji_button.search_results": "Trovuri",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Vizito & Plasi",
  "empty_column.account_hides_collections": "Ca uzanto selektis ne publikigar ca informo",
  "empty_column.account_suspended": "Konto restriktesis",
  "empty_column.account_timeline": "No toots here!",
  "empty_column.account_unavailable": "Profilo esas nedisponebla",
  "empty_column.blocks": "Vu ne restriktis irga uzanti til nun.",
  "empty_column.bookmarked_statuses": "You don't have any bookmarked toots yet. When you bookmark one, it will show up here.",
  "empty_column.community": "La lokala tempolineo esas vakua. Skribez ulo publike por iniciar la agiveso!",
  "empty_column.direct": "Vu ankore ne havas irga direta mesaji. Kande vu sendos o recevos un, ol montresos hike.",
  "empty_column.domain_blocks": "Ne havas blokusita domeni ankore.",
  "empty_column.explore_statuses": "Nulo populareskas nun.",
  "empty_column.favourited_statuses": "Vu ankore ne havas irga posti favorizita. Kande vu favorizos un, ol montresos hike.",
  "empty_column.favourites": "Nulu favorizis ca posto. Kande ulu favorizis ol, lu montresos hike.",
  "empty_column.follow_requests": "Vu ne havas irga sequodemandi til nun. Kande vu ganas talo, ol montresos hike.",
  "empty_column.followed_tags": "Vu ankore ne sequis irga hashtago. Kande vu sequos un, ol montresos hike.",
  "empty_column.hashtag": "Esas ankore nulo en ta gretovorto.",
  "empty_column.home": "Vua hemtempolineo esas desplena!",
  "empty_column.list": "There is nothing in this list yet.",
  "empty_column.mutes": "Vu ne silencigis irga uzanti til nun.",
  "empty_column.notification_requests": "Finis. Kande vu recevas nova savigi, oli aparos hike segun vua preferaji.",
  "empty_column.notifications": "Tu havas ankore nula savigo. Komunikez kun altri por debutar la konverso.",
  "empty_column.public": "Esas nulo hike! Skribez ulo publike, o manuale sequez uzeri de altra instaluri por plenigar ol.",
  "error.unexpected_crash.explanation": "Pro eroro en nia kodexo o vidilkonciliebloproblemo, ca pagino ne povas korekte montresar.",
  "error.unexpected_crash.explanation_addons": "Ca pagino ne povas korekte montresar. Ca eroro posible kauzigesas vidilplusajo o automata tradukutensili.",
  "error.unexpected_crash.next_steps": "Probez rifreshar pagino. Se to ne helpas, vu forsan ankore povas uzar Mastodon per diferenta vidilo o provizita softwaro.",
  "error.unexpected_crash.next_steps_addons": "Probez desebligar ili e rifreshar la pagino.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiez amastraso a klipplanko",
  "errors.unexpected_crash.report_issue": "Reportigez problemo",
  "explore.suggested_follows": "Personi",
  "explore.title": "Tendenca",
  "explore.trending_links": "Novaji",
  "explore.trending_statuses": "Posti",
  "explore.trending_tags": "Hashtagi",
  "featured_carousel.current": "<sr>Afisho</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Pinglizita Afisho} other {Pinglizita Afishi}}",
  "featured_carousel.slide": "Afisho {current, number} ek {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Recente vu afishigis pri {items}. Ka adjuntez ci kom estalita gretvorti?",
  "featured_tags.suggestions.add": "Adjuntez",
  "featured_tags.suggestions.added": "Aranjez vua estalita gretvorti irgatempe che <link>Redaktez Profilo > Estalita gretvorti</link>.",
  "featured_tags.suggestions.dismiss": "Nedanki",
  "filter_modal.added.context_mismatch_explanation": "Ca filtrilgrupo ne uzesis ad informo di ca adirita afisho.",
  "filter_modal.added.context_mismatch_title": "Kontenajneparigeso!",
  "filter_modal.added.expired_explanation": "Ca filtrilgrupo expiris, vu bezonas chanjar expirtempo por apliko.",
  "filter_modal.added.expired_title": "Expirinta filtrilo!",
  "filter_modal.added.review_and_configure": "Por kontrolar e plu ajustar ca filtrilgrupo, irez a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filtrilpreferaji",
  "filter_modal.added.settings_link": "preferajpagino",
  "filter_modal.added.short_explanation": "Ca posto adjuntesas a ca filtrilgrupo: {title}.",
  "filter_modal.added.title": "Filtrilo adjuntesas!",
  "filter_modal.select_filter.context_mismatch": "ne relatesas kun ca informo",
  "filter_modal.select_filter.expired": "expiris",
  "filter_modal.select_filter.prompt_new": "Nova grupo: {name}",
  "filter_modal.select_filter.search": "Trovez o kreez",
  "filter_modal.select_filter.subtitle": "Usez disponebla grupo o kreez novajo",
  "filter_modal.select_filter.title": "Filtragez ca posto",
  "filter_modal.title.status": "Filtragez posto",
  "filter_warning.matches_filter": "Samas kam filtrilo \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "De {count, plural,=0 {nulu} one {1 persono} other {# personi}} quan vu forsan konocas",
  "filtered_notifications_banner.title": "Filtrilita savigi",
  "firehose.all": "Omno",
  "firehose.local": "Ca servilo",
  "firehose.remote": "Altra servili",
  "follow_request.authorize": "Yurizar",
  "follow_request.reject": "Refuzar",
  "follow_requests.unlocked_explanation": "Quankam vua konto ne klefklozesis, la {domain} laborero pensas ke vu forsan volas kontralar sequodemandi de ca konti manuale.",
  "follow_suggestions.curated_suggestion": "Selektato de jeranto",
  "follow_suggestions.dismiss": "Ne montrez denove",
  "follow_suggestions.featured_longer": "Selektesis da la grupo di {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populara inter personi quan vu sequas",
  "follow_suggestions.hints.featured": "Ca profilo selektesis da la grupo di {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ca profilo esas populara inter personi quan vu sequas.",
  "follow_suggestions.hints.most_followed": "Vua profilo esas un de maxim sequita sur {domain}.",
  "follow_suggestions.hints.most_interactions": "Ca profilo recente populareskis sur {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ca profilo esas simila a la profili quan vu recente sequis.",
  "follow_suggestions.personalized_suggestion": "Personalita sugestato",
  "follow_suggestions.popular_suggestion": "Populara sugestato",
  "follow_suggestions.popular_suggestion_longer": "Populara sur {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Simila a profili quan vu recente sequis",
  "follow_suggestions.view_all": "Videz omno",
  "follow_suggestions.who_to_follow": "Sequindo",
  "followed_tags": "Hashtagi sequita",
  "footer.about": "Pri co",
  "footer.directory": "Profilcheflisto",
  "footer.get_app": "Obtenez la softwaro",
  "footer.keyboard_shortcuts": "Kombini di klavi",
  "footer.privacy_policy": "Guidilo pri privateso",
  "footer.source_code": "Vidar la fontokodexo",
  "footer.status": "Stando",
  "footer.terms_of_service": "Serveskondicioni",
  "generic.saved": "Sparesis",
  "getting_started.heading": "Debuto",
  "hashtag.admin_moderation": "Desklozar administrointervizajo por #{name}",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sen {additional}",
  "hashtag.column_settings.select.no_options_message": "Nula sugestati",
  "hashtag.column_settings.select.placeholder": "Insertez gretvorti…",
  "hashtag.column_settings.tag_mode.all": "Omna co",
  "hashtag.column_settings.tag_mode.any": "Irga co",
  "hashtag.column_settings.tag_mode.none": "Nula co",
  "hashtag.column_settings.tag_toggle": "Include additional tags in this column",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} partoprenanto} other {{counter} partoprenanti}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} posto} other {{counter} posti}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} posto} other {{counter} posti}} hodie",
  "hashtag.feature": "Estalez che profilo",
  "hashtag.follow": "Sequar gretvorto",
  "hashtag.unfeature": "Ne estalez che profilo",
  "hashtag.unfollow": "Dessequar gretvorto",
  "hashtags.and_other": "…e {count, plural, one {# plusa}other {# plusa}}",
  "hints.profiles.followers_may_be_missing": "Sequanti di ca profilo forsan ne esas hike.",
  "hints.profiles.follows_may_be_missing": "Sequati di ca profilo forsan ne esas hike.",
  "hints.profiles.posts_may_be_missing": "Kelka posti sur ca profilo forsan ne esas hike.",
  "hints.profiles.see_more_followers": "Vidar plu multa sequanti sur {domain}",
  "hints.profiles.see_more_follows": "Vidar plu multa sequati sur {domain}",
  "hints.profiles.see_more_posts": "Vidar plu multa posti sur {domain}",
  "home.column_settings.show_quotes": "Montrez citi",
  "home.column_settings.show_reblogs": "Montrar repeti",
  "home.column_settings.show_replies": "Montrar respondi",
  "home.hide_announcements": "Celez anunci",
  "home.pending_critical_update.body": "Voluntez aktualigar vua Mastodon-servilo tam balde kam es posibla!",
  "home.pending_critical_update.link": "Vidar aktualigaji",
  "home.pending_critical_update.title": "Sekuresala aktualigajo gravega disponebla!",
  "home.show_announcements": "Montrez anunci",
  "ignore_notifications_modal.disclaimer": "Mastodon ne povas savigar uzanti ke vu ignoris olia savigi. Ignorar savigi ne cesos ipse mesaji sendesar.",
  "ignore_notifications_modal.filter_instead": "Filtrar vice",
  "ignore_notifications_modal.filter_to_act_users": "Vu povos aceptar, refuzar o raportar uzanti",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtro helpas evitar posibla konfuzo",
  "ignore_notifications_modal.filter_to_review_separately": "Vu povas kontrolar filtrita savigi separe",
  "ignore_notifications_modal.ignore": "Ignorez savigi",
  "ignore_notifications_modal.limited_accounts_title": "Ka ignorar savigi de jerita konti?",
  "ignore_notifications_modal.new_accounts_title": "Ka ignorar savigi de nova konti?",
  "ignore_notifications_modal.not_followers_title": "Ka ignorar savigi de personi qua ne sequas vu?",
  "ignore_notifications_modal.not_following_title": "Ka ignorar savigi de personi quan vu ne sequas?",
  "ignore_notifications_modal.private_mentions_title": "Ka ignorar savigi de nekonocita privata mencionii?",
  "info_button.label": "Helpo",
  "info_button.what_is_alt_text": "<h1>Quo alternativa texto es?</h1> <p>On povas bonigar adireblo e kompreno por omno per skribar klara, deslonga e fakta alternative texto.</p>",
  "interaction_modal.go": "Irar",
  "interaction_modal.no_account_yet": "Ka vu ne havas konto ankore?",
  "interaction_modal.on_another_server": "Che diferanta servilo",
  "interaction_modal.on_this_server": "Che ca servilo",
  "interaction_modal.username_prompt": "Exemple {example}",
  "intervals.full.days": "{number, plural, one {# dio} other {# dii}}",
  "intervals.full.hours": "{number, plural, one {# horo} other {# hori}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minuti}}",
  "keyboard_shortcuts.back": "to navigate back",
  "keyboard_shortcuts.blocked": "to open blocked users list",
  "keyboard_shortcuts.boost": "Repetez posto",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Deskripto",
  "keyboard_shortcuts.down": "to move down in the list",
  "keyboard_shortcuts.enter": "to open status",
  "keyboard_shortcuts.explore": "Apertez tendenca tempolineo",
  "keyboard_shortcuts.favourite": "Favorizez ca posto",
  "keyboard_shortcuts.favourites": "Apertez listo di favoriziti",
  "keyboard_shortcuts.federated": "to open federated timeline",
  "keyboard_shortcuts.heading": "Keyboard Shortcuts",
  "keyboard_shortcuts.home": "to open home timeline",
  "keyboard_shortcuts.hotkey": "Rapidklavo",
  "keyboard_shortcuts.legend": "to display this legend",
  "keyboard_shortcuts.local": "to open local timeline",
  "keyboard_shortcuts.mention": "to mention author",
  "keyboard_shortcuts.muted": "to open muted users list",
  "keyboard_shortcuts.my_profile": "to open your profile",
  "keyboard_shortcuts.notifications": "to open notifications column",
  "keyboard_shortcuts.open_media": "Desklozar audvidaji",
  "keyboard_shortcuts.pinned": "Desklozar listo di adpinglita afishi",
  "keyboard_shortcuts.profile": "to open author's profile",
  "keyboard_shortcuts.quote": "Citez afisho",
  "keyboard_shortcuts.reply": "to reply",
  "keyboard_shortcuts.requests": "to open follow requests list",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "to show/hide CW field",
  "keyboard_shortcuts.start": "to open \"get started\" column",
  "keyboard_shortcuts.toggle_hidden": "to show/hide text behind CW",
  "keyboard_shortcuts.toggle_sensitivity": "Montrar/celar audvidaji",
  "keyboard_shortcuts.toot": "to start a brand new toot",
  "keyboard_shortcuts.translate": "por tradukar mesajo",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "to move up in the list",
  "lightbox.close": "Klozar",
  "lightbox.next": "Nexta",
  "lightbox.previous": "Antea",
  "lightbox.zoom_in": "Grandigez a reala grandeso",
  "lightbox.zoom_out": "Grandigez por fitigar",
  "limited_account_hint.action": "Jus montrez profilo",
  "limited_account_hint.title": "Ca profilo celesas dal jereri di {domain}.",
  "link_preview.author": "Da {name}",
  "link_preview.more_from_author": "Plua de {name}",
  "link_preview.shares": "{count, plural,one {{counter} posto} other {{counter} posti}}",
  "lists.add_member": "Adjuntar",
  "lists.add_to_list": "Adjuntar ad listo",
  "lists.add_to_lists": "Adjuntar {name} ad listi",
  "lists.create": "Krear",
  "lists.create_a_list_to_organize": "Krear nova listo por organizar vua hemfluo",
  "lists.create_list": "Krear listo",
  "lists.delete": "Efacez listo",
  "lists.done": "Finis",
  "lists.edit": "Redaktar listo",
  "lists.exclusive": "Celar membri sur Hemo",
  "lists.exclusive_hint": "Se ulu es en ca listo, celez lu sur vua hemfluo por evitar vidar lua afishi denove.",
  "lists.find_users_to_add": "Serchi uzanti por adjuntar",
  "lists.list_members_count": "{count, plural,one {# membro} other {#membri}}",
  "lists.list_name": "Listonomo",
  "lists.new_list_name": "Nova listonomo",
  "lists.no_lists_yet": "Nula listi ankore.",
  "lists.no_members_yet": "Nula membri ankore.",
  "lists.no_results_found": "Nula rezulto trovigesis.",
  "lists.remove_member": "Forigar",
  "lists.replies_policy.followed": "Irga sequita uzanto",
  "lists.replies_policy.list": "Membro di listo",
  "lists.replies_policy.none": "Nulu",
  "lists.save": "Konservar",
  "lists.search": "Serchar",
  "lists.show_replies_to": "Inkluzar respondi de listomembri",
  "load_pending": "{count, plural, one {# nova kozo} other {# nova kozi}}",
  "loading_indicator.label": "Kargante…",
  "media_gallery.hide": "Celar",
  "moved_to_account_banner.text": "Vua konto {disabledAccount} es nune desaktiva pro ke vu movis a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Celez de savigi",
  "mute_modal.hide_options": "Celez preferaji",
  "mute_modal.indefinite": "Til me dessilencigas lu",
  "mute_modal.show_options": "Montrez preferaji",
  "mute_modal.they_can_mention_and_follow": "Lu povas mencionar e sequar vu, ma vu ne vidos lu.",
  "mute_modal.they_wont_know": "Lu ne savos ke lu silencigesis.",
  "mute_modal.title": "Ka silencigar uzanto?",
  "mute_modal.you_wont_see_mentions": "Vu ne vidos posti qua mencionas lu.",
  "mute_modal.you_wont_see_posts": "Lu ankore povas vidar vua posti, ma vu ne vidos lua.",
  "navigation_bar.about": "Pri co",
  "navigation_bar.account_settings": "Pasvorto e sekureso",
  "navigation_bar.administration": "Administro",
  "navigation_bar.advanced_interface": "Apertez per retintervizajo",
  "navigation_bar.automated_deletion": "Automata postoefaco",
  "navigation_bar.blocks": "Blokusita uzeri",
  "navigation_bar.bookmarks": "Lektosigni",
  "navigation_bar.direct": "Privata mencioni",
  "navigation_bar.domain_blocks": "Blokusita domeni",
  "navigation_bar.favourites": "Favoriziti",
  "navigation_bar.filters": "Silencigita vorti",
  "navigation_bar.follow_requests": "Demandi di sequado",
  "navigation_bar.followed_tags": "Hashtagi sequita",
  "navigation_bar.follows_and_followers": "Sequati e sequanti",
  "navigation_bar.import_export": "Importaco e exportaco",
  "navigation_bar.lists": "Listi",
  "navigation_bar.logout": "Ekirar",
  "navigation_bar.moderation": "Jero",
  "navigation_bar.mutes": "Celita uzeri",
  "navigation_bar.opened_in_classic_interface": "Posti, konti e altra pagini specifika apertesas en la retovidilo klasika.",
  "navigation_bar.preferences": "Preferi",
  "navigation_bar.privacy_and_reach": "Privateso e atingeso",
  "navigation_bar.search": "Serchez",
  "navigation_bar.search_trends": "Sercho / Tendenco",
  "not_signed_in_indicator.not_signed_in": "Vu mustas enirar por acesar ca moyeno.",
  "notification.admin.report": "{name} raportizis {target}",
  "notification.admin.report_account": "{name} raportis {count, plural,one {1 posto} other {# posti}} de {target} pro {category}",
  "notification.admin.report_account_other": "{name} raportis {count, plural,one {1 posto} other {# posti}} de {target}",
  "notification.admin.report_statuses": "{name} raportis {target} pro {category}",
  "notification.admin.report_statuses_other": "{name} raportis {target}",
  "notification.admin.sign_up": "{name} registresis",
  "notification.admin.sign_up.name_and_others": "{name} e {count, plural,one {# altru} other {#altri}} enrejistris",
  "notification.annual_report.message": "Yen vua ye {year} #Wrapstodon!",
  "notification.annual_report.view": "Vidar #Wrapstodon",
  "notification.favourite": "{name} favorizis tua mesajo",
  "notification.favourite.name_and_others_with_link": "{name} e <a>{count, plural,one {# altru} other {# altri}}</a> stelumis vua afisho",
  "notification.favourite_pm": "{name} prizis vua privata menciono",
  "notification.favourite_pm.name_and_others_with_link": "{name} e <a>{count, plural,one {# altro} other {# altri}}</a> prizis vua privata menciono",
  "notification.follow": "{name} sequeskis tu",
  "notification.follow.name_and_others": "{name} e <a>{count, plural,one {# altro} other {# altri}}</a> sequis vu",
  "notification.follow_request": "{name} demandas sequar vu",
  "notification.follow_request.name_and_others": "{name} e {count, plural,one {# altru} other {# altri}} volas sequar vu",
  "notification.label.mention": "Mencionez",
  "notification.label.private_mention": "Privata menciono",
  "notification.label.private_reply": "Privata respondo",
  "notification.label.quote": "{name} citis vua afisho",
  "notification.label.reply": "Respondez",
  "notification.mention": "Mencionez",
  "notification.mentioned_you": "{name} mencionis vu",
  "notification.moderation-warning.learn_more": "Lernez plu",
  "notification.moderation_warning": "Vu recevis jeraverto",
  "notification.moderation_warning.action_delete_statuses": "Kelka vua posti efacesis.",
  "notification.moderation_warning.action_disable": "Vua konto es desaktivigita.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Kelka vua posti markizesis quale sentoza.",
  "notification.moderation_warning.action_none": "Vua konto recevis jeraverto.",
  "notification.moderation_warning.action_sensitive": "Vua posti markizesos quale sentoza pos nun.",
  "notification.moderation_warning.action_silence": "Vua konto limitizesis.",
  "notification.moderation_warning.action_suspend": "Vua konto restriktesis.",
  "notification.own_poll": "Vua votinquesto fineskis",
  "notification.poll": "Votinquesto ube vu votis fineskis",
  "notification.quoted_update": "{name} redaktis afisho quan vu citas",
  "notification.reblog": "{name} repetis tua mesajo",
  "notification.reblog.name_and_others_with_link": "{name} e <a>{count, plural,one {# altru} other {#altri}}</a> repetis vua posto",
  "notification.relationships_severance_event": "Desganis konekteso kun {name}",
  "notification.relationships_severance_event.account_suspension": "Administranto de {from} restriktis {target}, do vu ne povas plue recevar novaji de lu o interagar kun lu.",
  "notification.relationships_severance_event.domain_block": "Administranto de {from} blokusis {target}, e anke {followersCount} de vua sequanti e {followingCount, plural, one {# konto} other {# konti}} quan vu sequas.",
  "notification.relationships_severance_event.learn_more": "Lernez plu",
  "notification.relationships_severance_event.user_domain_block": "Vu blokusis {target}, do efacis {followersCount} de vua sequanti e {followingCount, plural, one {# konto} other {#konti}} quan vu sequis.",
  "notification.status": "{name} nove postigis",
  "notification.update": "{name} redaktis afisho",
  "notification_requests.accept": "Aceptez",
  "notification_requests.accept_multiple": "{count, plural, one {Aceptar # demando…} other {Aceptar # demandi…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceptar demando} other {Aceptar demandi}}",
  "notification_requests.confirm_accept_multiple.message": "Vu aceptos {count, plural, one {1 savigdemando} other {# savigdemandi}}. Ka vu certe volas durar?",
  "notification_requests.confirm_accept_multiple.title": "Ka aceptar savigdemandi?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Ignorez demando} other {Ignorez demandi}}",
  "notification_requests.confirm_dismiss_multiple.message": "Vu ignoros {count, plural, one {1 savigdemando} other {# savigdemandi}}. Vu ne povas facile ganar {count, plural, one {ol} other {oli}} denove. Ka vu esas certe ke vu volas durar?",
  "notification_requests.confirm_dismiss_multiple.title": "Ka ignorar savigdemandi?",
  "notification_requests.dismiss": "Ignorez",
  "notification_requests.dismiss_multiple": "{count, plural,one {Ignorez # demando…} other {Ignorez # demandi…}}",
  "notification_requests.edit_selection": "Redaktar",
  "notification_requests.exit_selection": "Finas",
  "notification_requests.explainer_for_limited_account": "Savigi de ca konto filtresis pro ke la konto limitizesis da jeranto.",
  "notification_requests.explainer_for_limited_remote_account": "Savigi de ca konto filtresis pro ke la konto o olua servilo limitizesis da jeranto.",
  "notification_requests.maximize": "Parmontrez",
  "notification_requests.minimize_banner": "Celez banero di filtrita savigi",
  "notification_requests.notifications_from": "Savigi de {name}",
  "notification_requests.title": "Filtrita savigi",
  "notification_requests.view": "Videz savigi",
  "notifications.clear": "Efacar savigi",
  "notifications.clear_confirmation": "Ka tu esas certa, ke tu volas efacar omna tua savigi?",
  "notifications.clear_title": "Ka efacar savigi?",
  "notifications.column_settings.admin.report": "Nova raporti:",
  "notifications.column_settings.admin.sign_up": "Nova registranti:",
  "notifications.column_settings.alert": "Desktopavizi",
  "notifications.column_settings.favourite": "Favoriziti:",
  "notifications.column_settings.filter_bar.advanced": "Montrez omna kategorii",
  "notifications.column_settings.filter_bar.category": "Rapidfiltrilbaro",
  "notifications.column_settings.follow": "Nova sequanti:",
  "notifications.column_settings.follow_request": "Nova sequodemandi:",
  "notifications.column_settings.group": "Grupo",
  "notifications.column_settings.mention": "Mencioni:",
  "notifications.column_settings.poll": "Votinquestorezulti:",
  "notifications.column_settings.push": "Pulsavizi",
  "notifications.column_settings.quote": "Citi:",
  "notifications.column_settings.reblog": "Repeti:",
  "notifications.column_settings.show": "Montrar en kolumno",
  "notifications.column_settings.sound": "Plear sono",
  "notifications.column_settings.status": "New toots:",
  "notifications.column_settings.unread_notifications.category": "Nelektita avizi",
  "notifications.column_settings.unread_notifications.highlight": "Briligez nelektita avizi",
  "notifications.column_settings.update": "Redaktati:",
  "notifications.filter.all": "Omna",
  "notifications.filter.boosts": "Repeti",
  "notifications.filter.favourites": "Favoriziti",
  "notifications.filter.follows": "Sequati",
  "notifications.filter.mentions": "Mencioni",
  "notifications.filter.polls": "Votinquestorezulti",
  "notifications.filter.statuses": "Novaji de personi quon vu sequas",
  "notifications.grant_permission": "Donez permiso.",
  "notifications.group": "{count} avizi",
  "notifications.mark_as_read": "Markizez singla avizi quale lektita",
  "notifications.permission_denied": "Desktopavizi esas nedisplonebla pro antea refuzita vidilpermisdemando",
  "notifications.permission_denied_alert": "Komputilsavigi ne povas ebligesar, pro ke retumilpermiso desaceptesis antee",
  "notifications.permission_required": "Desktopavizi esas nedisplonebla pro ke bezonata permiso ne donesis.",
  "notifications.policy.accept": "Aceptez",
  "notifications.policy.accept_hint": "Montrez en savigi",
  "notifications.policy.drop": "Ignorez",
  "notifications.policy.drop_hint": "Nihiligez lu",
  "notifications.policy.filter": "Filtrez",
  "notifications.policy.filter_hint": "Sendez a enbuxo di filtrita savigi",
  "notifications.policy.filter_limited_accounts_hint": "Limitizesis da serviljeranti",
  "notifications.policy.filter_limited_accounts_title": "Jerita konti",
  "notifications.policy.filter_new_accounts.hint": "Kreesis depos {days, plural, one {1 dio} other {# dii}}",
  "notifications.policy.filter_new_accounts_title": "Nova konti",
  "notifications.policy.filter_not_followers_hint": "Inkluzanta personi qua sequas vu min kam {days, plural, one {1 dio} other {# dii}}",
  "notifications.policy.filter_not_followers_title": "Nesequanti",
  "notifications.policy.filter_not_following_hint": "Til vu manuale aprobas lu",
  "notifications.policy.filter_not_following_title": "Nesequati",
  "notifications.policy.filter_private_mentions_hint": "Filtrita se ol ne esas respondo a vua sua menciono o se vu sequas la sendanto",
  "notifications.policy.filter_private_mentions_title": "Nekonocita privata mencioni",
  "notifications.policy.title": "Regular savigi de…",
  "notifications_permission_banner.enable": "Ebligar komputilsavigi",
  "notifications_permission_banner.how_to_control": "Por ganar savigi kande Mastodon ne es desklozita, ebligez komputilsavigi.",
  "notifications_permission_banner.title": "Irga kozo ne pasas vu",
  "onboarding.follows.back": "Retro",
  "onboarding.follows.empty": "Regretinde, nula rezultajo povas montresar nune. Vu povas esforcar serchar, o irar al explorala pagino por trovar personi sequinda, o esforcar itere pose.",
  "onboarding.follows.search": "Serchar",
  "onboarding.follows.title": "Sequez personi por komencar",
  "onboarding.profile.discoverable": "Trovebligez mea profilo",
  "onboarding.profile.discoverable_hint": "Se vu selektas deskovrebleso che Mastodon, vua posti povas aparar en sercho-rezultaji e populari, e vua profilo forsan sugestesos a personi kun interesi simila a vua.",
  "onboarding.profile.display_name": "Publika nomo",
  "onboarding.profile.display_name_hint": "Vua tota nomo o vua gaya nomo…",
  "onboarding.profile.note": "Biografio",
  "onboarding.profile.note_hint": "Vu povas @mencionar altra personi o #hashtagi…",
  "onboarding.profile.title": "Kompletigez la profilo",
  "onboarding.profile.upload_avatar": "Kargez profiloportreto",
  "onboarding.profile.upload_header": "Kargez profilokapimajo",
  "password_confirmation.exceeds_maxlength": "La konfirmo dil pasvorto superesas la limito pri longeso di pasvorti",
  "password_confirmation.mismatching": "La konfirmo dil pasvorto ne egalesas",
  "picture_in_picture.restore": "Retropozez",
  "poll.closed": "Klozita",
  "poll.refresh": "Rifreshar",
  "poll.reveal": "Vidar rezultaji",
  "poll.total_people": "{count, plural, one {# persono} other {# personi}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# voti}}",
  "poll.vote": "Votar",
  "poll.voted": "Vu ja votis ca respondo",
  "poll.votes": "{votes, plural, one {# voto} other {# voti}}",
  "poll_button.add_poll": "Adjuntar votinquesto",
  "poll_button.remove_poll": "Forigar votinquesto",
  "privacy.change": "Aranjar privateso di mesaji",
  "privacy.direct.long": "Omnu quan mencionesis en la posto",
  "privacy.direct.short": "Privata menciono",
  "privacy.private.long": "Nur vua sequanti",
  "privacy.private.short": "Sequanti",
  "privacy.public.long": "Ulu de e ne de Mastodon",
  "privacy.public.short": "Publike",
  "privacy.quote.anyone": "{visibility}, citi permisita",
  "privacy.quote.disabled": "{visibility}, citi despermisita",
  "privacy.quote.limited": "{visibility}, citi limitizita",
  "privacy.unlisted.additional": "Co kondutas exakte kam publika, ecepte la posto ne aparos en nuna flui o gretvorti, exploro, o sercho di Mastodon, mem se vu esas volunta totkonte.",
  "privacy.unlisted.long": "Celita de Mastodon-serchrezulti, tendenci e publika tempolinei",
  "privacy.unlisted.short": "Deslauta publiko",
  "privacy_policy.last_updated": "Antea novajo ye {date}",
  "privacy_policy.title": "Privatesguidilo",
  "quote_error.edit": "Citi ne povas esar adjuntar kande redaktar afisho.",
  "quote_error.poll": "Cito ne esas permisita kun votinquesti.",
  "quote_error.private_mentions": "Cito ne esas permisita kun direta mencioni.",
  "quote_error.quote": "Nur un cito samtempe esas permisita.",
  "quote_error.unauthorized": "Vu ne esas yurizita por citar ca afisho.",
  "quote_error.upload": "Cito ne esas permisita kun audvidajatachaji.",
  "recommended": "Rekomendata",
  "refresh": "Rifreshez",
  "regeneration_indicator.please_stand_by": "Vartez.",
  "regeneration_indicator.preparing_your_home_feed": "Preparas vua hemfluo…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dio} other {# dii}} ante nun",
  "relative_time.full.hours": "{number, plural, one {# horo} other {# hori}} ante nun",
  "relative_time.full.just_now": "jus nun",
  "relative_time.full.minutes": "{number, plural, one {# minuto} other {# minuti}} ante nun",
  "relative_time.full.seconds": "{number, plural, one {# sekundo} other {# sekundi}} ante nun",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "nun",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "hodie",
  "remove_quote_hint.button_label": "Komprenas",
  "remove_quote_hint.message": "Vu povas agar ol de la {icon} preferajmenuo.",
  "remove_quote_hint.title": "Ka volas efacar vua citita afisho?",
  "reply_indicator.attachments": "{count, plural, one {# addonajo} other {# addonaji}}",
  "reply_indicator.cancel": "Nihiligar",
  "reply_indicator.poll": "Votinquesto",
  "report.block": "Restriktez",
  "report.block_explanation": "Vu ne vidos olia posti. Oli ne povas vidar vua posti o sequar vu. Oli savos ke oli restriktesis.",
  "report.categories.legal": "Legala",
  "report.categories.other": "Altra",
  "report.categories.spam": "Spamo",
  "report.categories.violation": "Kontenaj nesequas servilregulo",
  "report.category.subtitle": "Selektez maxim bona parigato",
  "report.category.title": "Savigez ni pri quo eventas kun ca {type}",
  "report.category.title_account": "profilo",
  "report.category.title_status": "posto",
  "report.close": "Fina",
  "report.comment.title": "Ka altra irgo quon vu pensas ke ni debas savar?",
  "report.forward": "Sendez a {target}",
  "report.forward_hint": "La konto esas de altra servilo. Vu volas sendar raportkopiur sen nomo ibe anke?",
  "report.mute": "Silencigez",
  "report.mute_explanation": "Vu ne vidos olia posti. Oli povas ankore sequar vu e vidar vua posti e ne savar ke oli silencigesis.",
  "report.next": "Nexta",
  "report.placeholder": "Plusa komenti",
  "report.reasons.dislike": "Me ne amas",
  "report.reasons.dislike_description": "Ol ne esas olo quon vu volas vidar",
  "report.reasons.legal": "Ol es nelegala",
  "report.reasons.legal_description": "Vu kredas ke ol violacas la lego di vua lando o la lando dil servilo",
  "report.reasons.other": "Ol esas altra ulo",
  "report.reasons.other_description": "La problemo ne fitas a altra kategorii",
  "report.reasons.spam": "Ol esas spamo",
  "report.reasons.spam_description": "Mala ligili, falsa interago o repetiva repliki",
  "report.reasons.violation": "Ol nesequas servilreguli",
  "report.reasons.violation_description": "Vu remarkas ke ol nesequas partikulara reguli",
  "report.rules.subtitle": "Selektez relatata omno",
  "report.rules.title": "Quala reguli nesequesas?",
  "report.statuses.subtitle": "Selektez relatata omno",
  "report.statuses.title": "Ka existas irga posti quo suportas ca raporto?",
  "report.submit": "Sendar",
  "report.target": "Denuncante",
  "report.thanks.take_action": "Yen vua preferaji por regularar quon vu vidas sur Mastodon:",
  "report.thanks.take_action_actionable": "Dum ke ni kontrolas co, vu povas demarshar kontra @{name}:",
  "report.thanks.title": "Ka vu ne volas vidar co?",
  "report.thanks.title_actionable": "Danko por raportizar, ni kontrolos co.",
  "report.unfollow": "Desequez @{name}",
  "report.unfollow_explanation": "Vu sequas ca konto.",
  "report_notification.attached_statuses": "{count, plural,one {{count} posti} other {{count} posti}} addonita",
  "report_notification.categories.legal": "Legala",
  "report_notification.categories.legal_sentence": "deslegala kontenajo",
  "report_notification.categories.other": "Altra",
  "report_notification.categories.other_sentence": "altra",
  "report_notification.categories.spam": "Spamo",
  "report_notification.categories.spam_sentence": "sendacho",
  "report_notification.categories.violation": "Regulnesequo",
  "report_notification.categories.violation_sentence": "regulviolaco",
  "report_notification.open": "Apertez raporto",
  "search.no_recent_searches": "Nula serchi recenta",
  "search.placeholder": "Serchez",
  "search.quick_action.account_search": "Profili qui asortas {x}",
  "search.quick_action.go_to_account": "Irez al profilo {x}",
  "search.quick_action.go_to_hashtag": "Irez al hashtago {x}",
  "search.quick_action.open_url": "Apertez URL per Mastodon",
  "search.quick_action.status_search": "Posti qui asortas {x}",
  "search.search_or_paste": "Serchar o pozar URL",
  "search_popout.full_text_search_disabled_message": "Nedisponebla che {domain}.",
  "search_popout.full_text_search_logged_out_message": "Nur disponebla enirite.",
  "search_popout.language_code": "ISO linguokodexo",
  "search_popout.options": "Opcioni serchala",
  "search_popout.quick_actions": "Agi rapida",
  "search_popout.recent": "Lasta serchi",
  "search_popout.specific_date": "dato specifika",
  "search_popout.user": "uzanto",
  "search_results.accounts": "Profili",
  "search_results.all": "Omna",
  "search_results.hashtags": "Gretvorti",
  "search_results.no_results": "Nula rezulto.",
  "search_results.no_search_yet": "Probez serchar afishi, profili o gretvorti.",
  "search_results.see_all": "Videz omni",
  "search_results.statuses": "Posti",
  "search_results.title": "Serchar \"{q}\"",
  "server_banner.about_active_users": "Personi quo uzas ca servilo dum antea 30 dii (monate aktiva uzanti)",
  "server_banner.active_users": "aktiva uzanti",
  "server_banner.administered_by": "Administresis da:",
  "server_banner.is_one_of_many": "{domain} esas 1 de multa sendependa servili di Mastodon quan vu povas uzar por partoprenar en la fediverso.",
  "server_banner.server_stats": "Servilstatistiko:",
  "sign_in_banner.create_account": "Kreez konto",
  "sign_in_banner.follow_anyone": "On povas sequar ulu sur tota fediverso e vidar omno ye kronologia ordino. Nula algoritmi, reklami o klikatrapo omnaloke.",
  "sign_in_banner.mastodon_is": "Mastodon esas la maxim bona voyo por saveskar eventi.",
  "sign_in_banner.sign_in": "Enirez",
  "sign_in_banner.sso_redirect": "Enirar o krear konto",
  "status.admin_account": "Apertez jerintervizajo por @{name}",
  "status.admin_domain": "Apertez jerintervizajo por {domain}",
  "status.admin_status": "Open this status in the moderation interface",
  "status.all_disabled": "Diskonocigi e citi esas desaktivigita",
  "status.block": "Restriktez @{name}",
  "status.bookmark": "Lektosigno",
  "status.cancel_reblog_private": "Desrepetez",
  "status.cannot_quote": "Vu ne esas permisita citar ca afisho",
  "status.cannot_reblog": "Ca posto ne povas repetesar",
  "status.contains_quote": "Kontenas cito",
  "status.continued_thread": "Durigita postaro",
  "status.copy": "Copy link to status",
  "status.delete": "Efacar",
  "status.detailed_status": "Detala konversvido",
  "status.direct": "Private mencionez @{name}",
  "status.direct_indicator": "Privata menciono",
  "status.edit": "Redaktar",
  "status.edited": "Lastatempe redaktesar ye {date}",
  "status.edited_x_times": "Redaktesis ye {count, plural, one {{count} foyo} other {{count} foyi}}",
  "status.embed": "Ganez adherkodexo",
  "status.favourite": "Favorizar",
  "status.filter": "Filtragez ca posto",
  "status.history.created": "{name} kreis ye {date}",
  "status.history.edited": "{name} redaktis ye {date}",
  "status.load_more": "Kargar plu",
  "status.media.open": "Klikez por apertar",
  "status.media.show": "Klikez por montrar",
  "status.media_hidden": "Audvidaji es celita",
  "status.mention": "Mencionar @{name}",
  "status.more": "Plu",
  "status.mute": "Silencigez @{name}",
  "status.mute_conversation": "Silencigez konverso",
  "status.open": "Detaligar ca mesajo",
  "status.pin": "Pinglagez che profilo",
  "status.quote": "Citez",
  "status.quote.cancel": "Anulez cito",
  "status.quote_error.blocked_account_hint.title": "Ca afisho esas celita por ke vu blokusis @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Ca afisho esas celita por ke vu blokusis @{domain}.",
  "status.quote_error.filtered": "Celita por un de vua filtrili",
  "status.quote_error.limited_account_hint.action": "Montrez nure",
  "status.quote_error.limited_account_hint.title": "Ca konto esas celita da jeranti di {domain}.",
  "status.quote_error.muted_account_hint.title": "Ca afisho esas celita por ke vu silentigis @{name}.",
  "status.quote_error.not_available": "Profilo esas nedisponebla",
  "status.quote_error.pending_approval": "Afisho pendas",
  "status.quote_error.pending_approval_popout.body": "Che Mastodon, vu povas regar ka ulu povas citar vu.",
  "status.quote_error.revoked": "Afisho esas efacita da afishiganto",
  "status.quote_followers_only": "Nur sequanti povas citar ca afisho",
  "status.quote_manual_review": "Afishiganto permanue kontrolos",
  "status.quote_noun": "Cito",
  "status.quote_policy_change": "Chanjez persono quan povas citar",
  "status.quote_post_author": "Citis afisho da @{name}",
  "status.quote_private": "Privata afishi ne povas esar citita",
  "status.quotes.empty": "Nulu citas ca afisho ankore.",
  "status.quotes.local_other_disclaimer": "Citi quan esar desaprobita da afishiganto ne esar montrita.",
  "status.quotes.remote_other_disclaimer": "Nur citi de {domain} certe esas montrita hike.",
  "status.quotes_count": "{count, plural,one {{counter} cito} other {{counter} citi}}",
  "status.read_more": "Lektez plu",
  "status.reblog": "Repetez",
  "status.reblog_or_quote": "Diskonocez o citez",
  "status.reblog_private": "Ankorfoye kunhavigez kun vua sequanti",
  "status.reblogged_by": "{name} repetis",
  "status.reblogs.empty": "Nulu ja repetis ca posto. Kande ulu facas lo, lu montresos hike.",
  "status.reblogs_count": "{count, plural,one {{counter} diskonoco} other {{counter} diskonoci}}",
  "status.redraft": "Efacez e riskisigez",
  "status.remove_bookmark": "Forigar lektosigno",
  "status.remove_favourite": "Forigar de priziti",
  "status.remove_quote": "Efacez",
  "status.replied_in_thread": "Respondesis en postaro",
  "status.replied_to": "Respondis a {name}",
  "status.reply": "Respondar",
  "status.replyAll": "Respondar a filo",
  "status.report": "Denuncar @{name}",
  "status.request_quote": "Demandez cito",
  "status.revoke_quote": "Efacez mea afisho de afisho da @{name}",
  "status.sensitive_warning": "Trubliva kontenajo",
  "status.share": "Partigez",
  "status.show_less_all": "Montrez min por omno",
  "status.show_more_all": "Montrez plu por omno",
  "status.show_original": "Montrez originalo",
  "status.title.with_attachments": "{user} afishis {attachmentCount, plural, one {addonajo} other {{attachmentCount} addonaji}}",
  "status.translate": "Tradukez",
  "status.translated_from_with": "Tradukita de {lang} per {provider}",
  "status.uncached_media_warning": "Previdajo nedisponebla",
  "status.unmute_conversation": "Desilencigez konverso",
  "status.unpin": "Depinglagez de profilo",
  "subscribed_languages.lead": "Nur posti en selektita lingui aparos en vua hemo e listotempolineo pos chanjo. Selektez nulo por ganar posti en omna lingui.",
  "subscribed_languages.save": "Sparez chanji",
  "subscribed_languages.target": "Chanjez abonita lingui por {target}",
  "tabs_bar.home": "Hemo",
  "tabs_bar.menu": "Menuo",
  "tabs_bar.notifications": "Savigi",
  "tabs_bar.publish": "Nova afisho",
  "tabs_bar.search": "Serchez",
  "terms_of_service.title": "Servtermini",
  "time_remaining.days": "{number, plural, one {# dio} other {# dii}} restas",
  "time_remaining.hours": "{number, plural, one {# horo} other {# hori}} restas",
  "time_remaining.minutes": "{number, plural, one {# minuto} other {# minuti}} restas",
  "time_remaining.moments": "Poka sekundi restas",
  "time_remaining.seconds": "{number, plural, one {# sekundo} other {# sekundi}} restas",
  "trends.counter_by_accounts": "{count, plural,one {{counter} persono} other {{counter} personi}} en antea {days, plural,one {dio} other {{days} dii}}",
  "trends.trending_now": "Populareskas nun",
  "ui.beforeunload": "Vua skisato perdesos se vu ekiras Mastodon.",
  "units.short.billion": "{count}G",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Tenar e destenar por adkargar",
  "upload_button.label": "Adjuntar imaji, video o sondosiero",
  "upload_error.limit": "Dosieradkarglimito ecesesis.",
  "upload_error.poll": "Dosieradkargo ne permisesas kun votinquesti.",
  "upload_error.quote": "Dosieradkargo ne esas permisita kun citi.",
  "upload_form.drag_and_drop.instructions": "Por tenar audvidajaddonajo, presez spaco o eniro. Presez spaco o eniro denove por destenar la audvidajatachajo en olua nova loko, o presez eskapo por nuligar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Tiro nuligesis.",
  "upload_form.drag_and_drop.on_drag_end": "Audvidajaddonajo {item} destenesis.",
  "upload_form.drag_and_drop.on_drag_over": "Audvidajaddonajo {item} movigesis.",
  "upload_form.drag_and_drop.on_drag_start": "Tenis audvidajaddonajo {item}.",
  "upload_form.edit": "Redaktar",
  "upload_progress.label": "Adkargas...",
  "upload_progress.processing": "Traktante…",
  "username.taken": "Ta uzantnomo ja es posedita. Provez altro",
  "video.close": "Klozez video",
  "video.download": "Deschargar dosiero",
  "video.exit_fullscreen": "Ekirez plena skreno",
  "video.expand": "Expansez video",
  "video.fullscreen": "Plena skreno",
  "video.hide": "Celez video",
  "video.pause": "Pauzez",
  "video.play": "Pleez",
  "visibility_modal.direct_quote_warning.text": "Se vu retenas la nuna preferaji, la enpozita cito esas chanjita ad ligilo.",
  "visibility_modal.direct_quote_warning.title": "Citi ne povas esar enpozita en privata mencioni",
  "visibility_modal.helper.direct_quoting": "Privata mencioni quan esas igita che Mastodon ne povas mencionita da altri.",
  "visibility_modal.helper.privacy_editing": "Videbleso ne povas esar chanjita pos afisho esar publikigita.",
  "visibility_modal.helper.privacy_private_self_quote": "Suciti di privata afishi ne povas esar publikigita.",
  "visibility_modal.helper.private_quoting": "Nursequanta afishi quan igita che Mastodon ne povas esar citita da altri.",
  "visibility_modal.helper.unlisted_quoting": "Kande personi citas vu, anke lia afisho esar celitos de tendenca tempolinei.",
  "visibility_modal.instructions": "Kontrolez qua povas interagar kun ca afisho. Vu povas irar ad <link>Preferaji > Afishigpredeterminitaji</link>.",
  "visibility_modal.privacy_label": "Videbleso",
  "visibility_modal.quote_followers": "Nur sequanti",
  "visibility_modal.quote_label": "Qua povas citar",
  "visibility_modal.quote_nobody": "Nur me",
  "visibility_modal.quote_public": "Irgu"
}
